export const STORAGE_KEYS = {
  KIOSK_DEVICE_ID: "availio_kiosk_device_id",
  LANDING_REDIRECTED: "kiosk_landing_redirected",
} as const;

export const KIOSK_TIME = {
  DEFAULT_TIMEOUT: 20,
  DEFAULT_WARNING_TIME: 5,
  IDLE_TIMEOUT: 25,
  WARNING_TIME: 10,
};

export const SPONSOR_IMAGE_COLS = 3;
